import React from "react";
import "./LocationMessageContent.scss";
import LazyLoad from "react-lazy-load";
import GoogleMapReact from "google-map-react";
import LocationMarker from "./LocationMarker";
import IconWithBackground from "containers/chat/IconWithBackground/IconWithBackground";
import { MdLocationOn } from "react-icons/md";
import { darkBlue } from "styles/colors.module.scss";
import { setLocationMessageForDealerSuggestions } from "actions/dealerSuggestionActions";
import { connect } from "react-redux";
import DealerLocationTabService from "services/DealerLocationTabService";

function LocationMessageContent(props) {
  const { message, isTransferred, highlighted, messageSource } = props;
  const highlightedClass = highlighted ? "highlighted" : "";
  const transferredClass = isTransferred & !highlighted ? "transferred" : "";
  const { latitude, longitude } = message;
  const encryptedGoogleAPIKey = window.apiKeys.googleAPIKey;
  const decryptedGoogleAPIKey = atob(encryptedGoogleAPIKey);

  const { activeLocationMessage } = props;
  const isCurrentMessageActiveLocationSuggestion =
    activeLocationMessage &&
    activeLocationMessage.messageId === message.messageId;
  const bulbColor = isCurrentMessageActiveLocationSuggestion
    ? "#fff"
    : darkBlue;
  const iconBgColor = isCurrentMessageActiveLocationSuggestion
    ? darkBlue
    : "#fff";
  const boxShadowClass = !isCurrentMessageActiveLocationSuggestion
    ? "icon-with-shadow"
    : "";

  const activateDealerLocationTab = () => {
    props.setLocationMessageForDealerSuggestions(message);
    DealerLocationTabService.suggestDealersFor(message);
  };

  return (
    <div
      className={`location-msg-ctr ${transferredClass} ${highlightedClass}`}
      data-testid="location-message-content"
    >
      <LazyLoad placeholder="loading map" offset={100} height="100%" width="100%">
        <div className="location-container">
          <GoogleMapReact
            bootstrapURLKeys={{
              key: decryptedGoogleAPIKey,
            }}
            center={[latitude, longitude]}
            zoom={15}
            draggable={true}
            clickableIcons={true}
          >
            <LocationMarker lat={latitude} lng={longitude} />
          </GoogleMapReact>
        </div>
      </LazyLoad>
      <div className="location-info">
        {message.locationName && (
          <div className="caption-content">{message.locationName}</div>
        )}
        {message.address && (
          <div className="caption-content">{message.address}</div>
        )}
        <div className="caption-content">
          <b>Latitude:</b> {latitude}
        </div>
        <div className="caption-content">
          <b>Longitude:</b> {longitude}
        </div>
      </div>
      {messageSource === "from" && (
        <div
          className={`dealer-suggestion ${boxShadowClass}`}
          onClick={activateDealerLocationTab}
        >
          <IconWithBackground
            icon={<MdLocationOn color={bulbColor} size="1.5em" />}
            backgroundColor={iconBgColor}
          />
        </div>
      )}
    </div>
  );
}
const mapStateToProps = (state) => ({
  activeLocationMessage: state.dealerLocationSuggestion.activeLocationMessage,
});

const mapDispatchToProps = {
  setLocationMessageForDealerSuggestions,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LocationMessageContent);
